import React from 'react';
import { HeroBanner, About, Features, Faq } from '/';

export const Home = ({ handleForm, navClick }) => {
    
    return (
        <div className="home">
            
            <HeroBanner handleForm={handleForm} navClick={navClick} />
            <About />

            <section className="page-border"></section>
            <Features navClick={navClick} />
            
            <section className="page-border"></section>
            <Faq />
        
        </div>
    );
};